import script from "./web-header.vue?vue&type=script&setup=true&lang=js"
export * from "./web-header.vue?vue&type=script&setup=true&lang=js"

import "./web-header.vue?vue&type=style&index=0&id=fc752f04&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/qd-chilecashy-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc752f04"]])

export default __exports__